export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";